import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { API } from "aws-amplify";
import { navigate } from "gatsby";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk, faCheck } from "@fortawesome/free-solid-svg-icons";

import config from "../../config";
import {
  createSubscriptionCheckoutSession,
  createPaymentCheckoutSession,
} from "../../graphql/mutations";
import { getProduct } from "../../graphql/queries";

import StripePortal from "./StripePortal";

import "./SubscribeForm.scss";

const stripePromise = loadStripe(config.stripeApiKey);

export class SubscribeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripe: null,
      products: [],
      selectedProduct: null,
      loading: false,
    };
    this.deployProduct = this.deployProduct.bind(this);
    this.openPaymentPortal = this.openPaymentPortal.bind(this);
    this.subscribeToProduct = this.subscribeToProduct.bind(this);
    this.openSubscriptionPortal = this.openSubscriptionPortal.bind(this);
    this.getProducts = this.getProducts.bind(this);
    this.getProduct = this.getProduct.bind(this);
    this.addProduct = this.addProduct.bind(this);
  }

  componentDidMount() {
    this.getProducts();
    this.verifySubscriptions();
    this.verifyProductOwnership();
  }

  async getProducts() {
    this.props.productNames.map((productName) => {
      // if (productName == "cloudstartLite") {
      //   this.addProduct({
      //     entityId: productName,
      //     paymentType: "bot",
      //     path: "//aws/management/landingzones/deploy-cblz"
      //   })
      // } else
      if (productName == "cloudstartPremium") {
        this.addProduct({
          entityId: productName,
          paymentType: "bot",
          path: "/deployfeedback",
        });
      } else if (productName !== "trial") {
        this.getProduct(productName);
      }
    });
  }

  async getProduct(productName) {
    let params = { entityId: productName };
    let response;
    try {
      response = await API.graphql({
        query: getProduct,
        variables: params,
        authMode: "API_KEY",
      });
    } catch (error) {
      console.log("Error: ", error);
      return;
    }

    if (!response.data.getProduct) {
      return;
    }

    this.addProduct(response.data.getProduct);
  }

  addProduct(product) {
    this.setState((previousState) => {
      let products = [...previousState.products, product];
      let sortingArray = [...this.props.productNames];
      let sortedProducts = products.sort(function (firstEl, secondEl) {
        return (
          sortingArray.indexOf(firstEl.entityId) -
          sortingArray.indexOf(secondEl.entityId)
        );
      });
      return {
        products: sortedProducts,
      };
    });
  }

  async openPaymentPortal({ priceId }) {
    try {
      let response = await API.graphql({
        query: createPaymentCheckoutSession,
        variables: {
          successUrl: window.location.href,
          cancelUrl: window.location.href,
          priceId: priceId,
          quantity: 1,
        },
      });
      let sessionId = response.data.createPaymentCheckoutSession.id;
      this.setState({ loading: true });
      let stripe = await stripePromise;
      stripe.redirectToCheckout({
        sessionId: sessionId,
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  }

  deployProduct(product) {
    navigate(product.path);
  }

  async openSubscriptionPortal({ priceId }) {
    try {
      let response = await API.graphql({
        query: createSubscriptionCheckoutSession,
        variables: {
          successUrl: window.location.href,
          cancelUrl: window.location.href,
          priceId: priceId,
        },
      });
      let sessionId = response.data.createSubscriptionCheckoutSession.id;
      this.setState({ loading: true });
      let stripe = await stripePromise;
      stripe.redirectToCheckout({
        sessionId: sessionId,
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  }

  subscribeToProduct(product) {
    this.openSubscriptionPortal({ priceId: product.defaultPrice.stripeId });
  }

  renderCloudStartPremiumProduct() {
    return (
      <>
        <div className="product-card__header">
          <h3 className="product-card__title">Archie Dedicated</h3>
          <span className="product-card__subtitle">Your very ownm Archie</span>
        </div>
        {/* TODO: get price from api for default price */}
        <div className="product-card__price">
          <span className="product-card__currency">£</span>
          <span className="product-card__price-value">--</span>
          <span className="product-card__frequency">/months</span>
        </div>
        {this.renderCloudStartPremiumDetails()}
      </>
    );
  }

  renderCloudStartPremiumDetails() {
    return (
      <ul className="list">
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Accounts/projects
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Resources
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Application Stacks
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Landing Zone
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Request & Share
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Dedicated Code Repository
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Training & Hosting
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Branding
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Self Managed
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Dedicated support
        </li>
      </ul>
    );
  }

  // renderCloudStartLiteProduct() {
  //   return (
  //     <>
  //       <div className="product-card__header">
  //         <h3 className="product-card__title">Archie Premium</h3>
  //         <span className="product-card__subtitle">
  //           Template Request & Customisation
  //         </span>
  //       </div>
  //       {/* TODO: get price from api for default price */}
  //       <div className="product-card__price">
  //         <span className="product-card__currency">£</span>
  //         <span className="product-card__price-value">-</span>
  //         <span className="product-card__frequency">extra cost /template</span>
  //       </div>
  //       {this.renderCloudStartLiteDetails()}
  //     </>
  //   )
  // }

  // renderCloudStartLiteDetails() {
  //   return (
  //     <ul className="list">
  //        <li className="list__item">
  //         <FontAwesomeIcon className="list__item-icon" icon={faCheck}/>
  //          Archie Standard
  //       </li>
  //       <li className="list__item">
  //         <FontAwesomeIcon className="list__item-icon" icon={faCheck}/>
  //          Request & Share Templates
  //       </li>
  //       <li className="list__item">
  //         <FontAwesomeIcon className="list__item-icon" icon={faCheck}/>
  //         <i>Dedicated Buddy</i>
  //       </li>
  //       <li className="list__item">
  //         <FontAwesomeIcon className="list__item-icon" icon={faAsterisk}/>
  //           Custom Landing Zone
  //       </li>
  //       <li className="list__item">
  //         <FontAwesomeIcon className="list__item-icon" icon={faAsterisk}/>
  //           Custom Cloud resources
  //       </li>
  //       <li className="list__item">
  //         <FontAwesomeIcon className="list__item-icon" icon={faAsterisk}/>
  //           Custom Infrastructure Stacks
  //       </li>
  //       <li className="list__item">
  //         <FontAwesomeIcon className="list__item-icon" icon={faAsterisk}/>
  //         <i>Partnership only</i>
  //       </li>
  //     </ul>
  //   )
  // }

  renderArchieProduct() {
    return (
      <>
        <div className="product-card__header">
          <h3 className="product-card__title">Archie SaaS</h3>
          <span className="product-card__subtitle">
            Self-Service Portal Access
          </span>
        </div>
        {/* TODO: get price from api for default price */}
        <div className="product-card__price">
          <span className="product-card__currency">£</span>
          <span className="product-card__price-value">49,99</span>
          <span className="product-card__frequency">/user/months</span>
        </div>
        {this.renderArchieDetails()}
      </>
    );
  }

  renderArchieDetails() {
    return (
      <ul className="list">
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Accounts/projects
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Resources
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Application Stacks
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Landing Zone *
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Request & Share *
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Cloudbuddies Managed
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faCheck} />
          Best efforts support
        </li>
        <li className="list__item">
          <FontAwesomeIcon className="list__item-icon" icon={faAsterisk} />
          <i>Landing zone sold separately</i>
        </li>
      </ul>
    );
  }

  renderProductDetails(product) {
    switch (product.entityId) {
      case "cloudstartPremium":
        return this.renderCloudStartPremiumProduct(product);
      case "archie":
        return this.renderArchieProduct(product);
      // case "cloudstartLite":
      //   return this.renderCloudStartLiteProduct(product)
      default:
        return <h3 className="product-card__title">{product.entityId}</h3>;
    }
  }

  renderPurchaseButton(product) {
    let { deployProduct, subscribeToProduct, state } = this;

    // if (product.entityId == "cloudstartLite") {
    //   return <button className="button button--disabled" disabled>Coming Soon</button>
    // }

    if (state.loading) {
      return <span className="button button--minor">Loading...</span>;
    } else {
      if (product.paymentType === "subscription") {
        return (
          <button
            className="button button--minor"
            onClick={() => subscribeToProduct(product)}
          >
            Subscribe
          </button>
        );
      } else {
        return (
          <button
            className="button button--minor"
            onClick={() => deployProduct(product)}
          >
            Contact Us
          </button>
        );
      }
    }
  }

  render() {
    let { state, props } = this;
    return (
      <div
        className={`subscribe-form ${
          props.compact ? "subscribe-form--compact" : ""
        } product-card__grid`}
      >
        {state.products.map((product) => {
          return (
            <div
              key={product.entityId}
              className={`product-card ${
                state.selectedProduct === product
                  ? "product-card--selected"
                  : ""
              }`}
            >
              <div className="product-card__body">
                {this.renderProductDetails(product)}
              </div>

              <div className="product-card__footer">
                {props.subscriptions &&
                props.subscriptions.includes(product.entityId) ? (
                  <StripePortal
                    returnUrl={window.location.href}
                    caption="Manage Subscription"
                  />
                ) : (
                  this.renderPurchaseButton(product)
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

SubscribeForm.propTypes = {
  user: PropTypes.object,
  compact: PropTypes.bool,
  productNames: PropTypes.arrayOf(PropTypes.string),
  subscriptions: PropTypes.arrayOf(PropTypes.string),
};

SubscribeForm.defaultProps = {
  productNames: [
    "archie",
    // "cloudstartLite",
    "cloudstartPremium",
  ],
  compact: false,
  subscriptions: [],
};

const mapStateToProps = (state) => ({
  user: state.user,
  subscriptions: state.subscriptions,
});

export default connect(mapStateToProps)(SubscribeForm);
